import { ReactElement } from 'react';
import { ColSizes, ROW_GUTTER } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { Col } from 'newcomponents/UI/Col';
import { Row } from 'newcomponents/UI/Row';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import './index.less';

const MARKET_GROUPS_LENGTH = 3;
const EVENTS_DEFAULT_COUNT = 9;
const MARKETS_GROUPS_COUNT = 10;
const MARKETS_SKELETON_WIDTH = 50;

export const MarketsListOnlySkeleton = ({
  eventsSkeletonCount = EVENTS_DEFAULT_COUNT
}: {
  eventsSkeletonCount?: number;
}): ReactElement => {
  const configs = useSportsbookConfigs();
  const isEuropeanLayout =
    configs.spbLayoutType === ESportsbookLayoutTypes.EUROPEAN;

  return (
    <>
      <div className="marketList__marketGroups__container">
        {createArray(MARKETS_GROUPS_COUNT).map(index => (
          <Skeleton
            key={index}
            active
            title={{
              style: {
                height: 32,
                width: isEuropeanLayout
                  ? 'calc(100% - 4px)'
                  : MARKETS_SKELETON_WIDTH,
                borderRadius: 8,
                margin: '0 2px 0 2px'
              }
            }}
            paragraph={false}
          />
        ))}
      </div>
      {createArray(MARKET_GROUPS_LENGTH).map(index => (
        <div
          key={index}
          style={{
            background: 'var(--v3-black-0)',
            overflow: 'hidden',
            borderRadius: '6px',
            marginBottom: '4px'
          }}
        >
          <Row
            wrap={false}
            style={{
              padding: 12,
              borderTop: '1px solid var(--v3-black-6)',
              borderBottom: '1px solid var(--v3-black-6)'
            }}
            className="marketHeaderSkeleton"
          >
            <Col flex="auto">
              <Skeleton
                title={{
                  style: {
                    marginTop: 0,
                    marginBottom: 0,
                    width: 150
                  }
                }}
                paragraph={false}
                active
              />
            </Col>
            <Col flex="none">
              <Skeleton
                title={{
                  style: {
                    marginTop: 0,
                    marginBottom: 0,
                    width: 18
                  }
                }}
                paragraph={false}
                active
              />
            </Col>
          </Row>
          <Row
            gutterV={ROW_GUTTER._4}
            gutterH={ROW_GUTTER._4}
            style={{ padding: '4px 12px 12px 12px' }}
          >
            {createArray(eventsSkeletonCount).map(key => (
              <Col xs={ColSizes.SIZE_8} key={key}>
                <Skeleton
                  title={{
                    style: {
                      marginTop: 8,
                      marginBottom: 0,
                      height: 32,
                      width: '100%'
                    }
                  }}
                  paragraph={false}
                  active
                />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </>
  );
};
